var _circle, _path, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "url(#paint0_linear_70_968)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6031 8.96568C20.0351 8.35012 19.2357 8 18.3982 8H15.5333C14.6315 8 13.7776 8.40561 13.2079 9.10457L12.4669 10.0136C12.0871 10.4796 11.5178 10.75 10.9167 10.75H10.3333C8.49239 10.75 7 12.3916 7 14.4167V22.6667C7 24.6917 8.49239 26.3333 10.3333 26.3333H23.6667C25.5076 26.3333 27 24.6917 27 22.6667V14.4167C27 12.3916 25.5076 10.75 23.6667 10.75H23.1253C22.5669 10.75 22.034 10.5166 21.6554 10.1062L20.6031 8.96568Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 4.33333,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_968",
    x1: 25.5,
    y1: 5.5,
    x2: 9.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BC3FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.dc454dc40f8cddc95f83d0ad7437ccef.svg";
export { ForwardRef as ReactComponent };